import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, XCircle, CheckCircle2 } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-16 bg-white text-slate-900 overflow-hidden" data-id="element-195">
      <div className="max-w-7xl mx-auto px-4" data-id="element-196">
        <div className="text-center mb-12" data-id="element-197">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-198">
            Transformación Real
          </h2>
          <p className="text-slate-600 text-lg" data-id="element-199">
            De la acción agotadora al avance estratégico
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center max-w-5xl mx-auto" data-id="element-200">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-slate-50 p-8 rounded-2xl border border-slate-200 relative" data-id="element-201">
            <div className="absolute -top-4 left-8 bg-slate-200 text-slate-700 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-202">
              Antes
            </div>
            <ul className="space-y-6 mt-4" data-id="element-203">
              {['Acción constante, pero cansancio acumulado', 'Resultados, pero difíciles de sostener', 'Equipo activo, pero dependiente de ti'].map((item, i) => <li key={i} className="flex items-start gap-4 text-slate-700" data-id="element-204">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-205" />
                  <span className="text-lg" data-id="element-206">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Arrow Indicator (Desktop) */}
          <div className="hidden md:flex justify-center text-slate-300" data-id="element-207">
            <ArrowRight className="w-12 h-12" data-id="element-208" />
          </div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl border-2 border-amber-400 shadow-lg relative" data-id="element-209">
            <div className="absolute -top-4 left-8 bg-amber-500 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-210">
              Después del entrenamiento
            </div>
            <ul className="space-y-6 mt-4" data-id="element-211">
              {['Dirección clara para 2026', 'Decisiones con foco', 'Liderazgo con intención', 'Avance creciente y sostenible'].map((item, i) => <li key={i} className="flex items-start gap-4 text-slate-900" data-id="element-212">
                  <CheckCircle2 className="w-6 h-6 text-amber-600 flex-shrink-0" data-id="element-213" />
                  <span className="text-lg font-medium" data-id="element-214">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}